import { GONKA_BECH32_PREFIX, GONKA_COIN_TYPE, GONKA_HD_PATH, GONKA_DECIMALS, GONKA_BASE_DENOM, GONKA_DISPLAY_DENOM, GONKA_SYMBOL, } from '@gonka-wallet/crypto';
export const GONKA_CHAIN = {
    chainId: 'gonka-mainnet',
    bech32Prefix: GONKA_BECH32_PREFIX,
    coinType: GONKA_COIN_TYPE,
    hdPath: GONKA_HD_PATH,
    denom: {
        base: GONKA_BASE_DENOM,
        display: GONKA_DISPLAY_DENOM,
        symbol: GONKA_SYMBOL,
        decimals: GONKA_DECIMALS,
    },
    avgBlockTimeMs: 5360,
};
/**
 * Iteration 5: a single same-origin entry. The browser hits `/api/chain/...`
 * and a reverse proxy (nginx in production, Vite `server.proxy` in dev)
 * forwards to the public Gonka nodes. The chain package never sees node URLs
 * directly.
 */
export const DEFAULT_RPC_SEEDS = [
    {
        url: '',
        pathPrefix: '/api/chain',
        label: 'Gonka Hub proxy',
    },
];
/**
 * Deprecated: kept as `null` for backward compatibility with code that still
 * accepts a booster URL parameter. Iteration 5 has no separate booster
 * service — all reads go through the same-origin REST proxy.
 */
export const DEFAULT_BOOSTER_URL = null;
export const EXPLORER_TX_URL_TEMPLATE = 'https://gonkahub.com/tx/{hash}';
export function formatExplorerUrl(hash, template = EXPLORER_TX_URL_TEMPLATE) {
    if (!template)
        return null;
    return template.replace('{hash}', hash);
}
//# sourceMappingURL=config.js.map